import { ActivatedRoute, Router } from '@angular/router';

import { CoachingSwitchboardService } from '../../coaching-base/switchboard';
import {
    composeCommitmentSummaryItemIdentifier,
    StatusView,
    TabRefId,
} from '../../coaching-detail';
import {
    navigateToExistingCommitment,
    navigateToExistingDraftCommitment,
    navigateToNewDraftCommitment,
} from '../../coaching-detail/navigate';

export function goToDraftOrCommitment(
    draftId: string,
    commitmentId: number,
    router: Router,
    activatedRoute: ActivatedRoute,
    switchboardService: CoachingSwitchboardService,
    statuses: StatusView[],
    promiseStatuses: (prom: Promise<any>) => Promise<any>,
    userId?: number,
): void {
    if (draftId != null || commitmentId != null) {
        // need to hold onto these in case the state changes before the promise resolves
        const prom = draftId
            ? navigateToExistingDraftCommitment(
                  router,
                  activatedRoute,
                  draftId,
                  undefined,
                  commitmentId,
                  undefined,
                  undefined,
                  undefined,
                  true,
                  userId,
              )
            : navigateToExistingCommitment(
                  router,
                  activatedRoute,
                  commitmentId,
                  undefined,
                  undefined,
                  undefined,
                  true,
                  userId,
              );
        promiseStatuses(prom)
            .then(() => {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                switchboardService.pillarTwo.connected()
                    ? switchboardService.pillarTwo.sbScrollIntoView(
                          TabRefId.COMMITMENTS,
                          composeCommitmentSummaryItemIdentifier({
                              commitmentId,
                              draftId,
                          }),
                      )
                    : Promise.resolve();
            })
            .catch(() => null);
    } else {
        promiseStatuses(
            navigateToNewDraftCommitment(
                router,
                activatedRoute,
                undefined,
                undefined,
                undefined,
                undefined,
                userId,
            ),
        )
            .then(() => {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                statuses.length !== 0 &&
                switchboardService.pillarTwo.connected()
                    ? switchboardService.pillarTwo.sbScrollIntoView(
                          TabRefId.COMMITMENTS,
                          null,
                          statuses[0].identifier,
                      )
                    : Promise.resolve();
            })
            .catch(() => null);
    }
}
